import './App.css';
import React from "react"
import {
    BrowserRouter as Router, Routes, Route,
} from "react-router-dom";

import Home from "./pages/Home";
import Layout from "./pages/Layout";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Projects from "./pages/Projects";
import DampGhosts from "./pages/DampGhosts";
import MumbleGenerator from "./pages/MumbleGenerator";
import SimpleNotes from "./pages/SimpleNotes";
import SimpleRiver from "./pages/SimpleRiver";

// https://www.digitalocean.com/community/tutorials/deploy-react-application-with-nginx-on-ubuntu
// deploy build

// npm run build
// scp -r build/* czoks@178.128.193.27:/var/www/bl1s.xyz/html
function App() {
    Title();

    return (<div className={"App"}>
        <h1>
            Bernard Lis
        </h1>
        <h3>
            Official Home Page
        </h3>

        <Router>
            <Routes>
                <Route path="/" element={<Layout/>}>
                    <Route index element={<Home/>}/>
                    <Route path="about" element={<About/>}/>
                    <Route path="contact" element={<Contact/>}/>
                    <Route path="projects" element={<Projects/>}/>
                    <Route path="damp-ghosts" element={<DampGhosts/>}/>
                    <Route path="mumble-generator" element={<MumbleGenerator/>}/>
                    <Route path="simple-notes" element={<SimpleNotes/>}/>
                    <Route path="simple-river" element={<SimpleRiver/>}/>
                </Route>
            </Routes>
        </Router>
    </div>);
}

function Title() {
    document.title = "Bernard Lis - Home Page";
}

export default App;
